module.exports = __webpack_public_path__ + "./static/img/icondis-1.d6f39df5e2677cf062b4effd6f6acee4.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-1.png
// module id = ./client/src/assets/img/company/icondis-1.png
// module chunks = 0